<template>
  <div class="game-header">
    <div class="left">
      <img src="@/assets/img/wingo/calendar.svg" alt="Session GIF" class="session-gif" />
      {{ sessionId }}
    </div>

    <div class="center">
      <i class="fa fa-user"></i>
      {{ onlinePlayers }}
    </div>

    <div class="right">
      <WingoCountdown
        :deadline="deadline"
        :countdownSize="'1.7rem'"
        :labelSize="'0.8rem'"
        :mainColor="'#ffea2f'"
        :mainFlipBackgroundColor="'#0e1b1d'"
        :secondFlipBackgroundColor="'#0e1b1d'"
        :showDays="false"
        :showHours="false"
        :showMinutes="true"
        :showSeconds="true"
        @timeElapsed="onCountdownFinish"
      />
    </div>
  </div>
</template>


<script setup>
import { toRefs } from 'vue'
import WingoCountdown from '@/components/WingoCountdown.vue'

const props = defineProps({
  sessionId: String,
  deadline: String,
  onlinePlayers: Number
})

// props'ları template'te direkt kullanmak için
const { sessionId, deadline, onlinePlayers } = toRefs(props)

const onCountdownFinish = () => {
  console.log('ROUND FINISHED – waiting result')
}
</script>


<style scoped>
.game-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  font-size: 14px;
  color: #ccc;
}

.left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;
  color: white;
  font-size: 14px;
}

.session-gif {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.center {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--background2);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  color: #d0d0d0;
}

.center i {
  font-size: 13px;
}

.right {
  text-align: right;
}

.countdown {
  font-size: 16px;
  font-weight: bold;
  color: white;
}

.place-bet {
  font-size: 11px;
  color: #fff;
  animation: blink 1s step-end infinite;
  margin-top: 2px;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
